<template>
  <div class="rfv-card-item" :style="`border-color: ${color}`">
    <div class="title-container">
      <div :style="`background-color: ${color};`" class="emoji-container">
        <p>{{ icon }}</p>
      </div>
      <h1>{{ title }}</h1>
    </div>

    <ul>
      <li v-for="item in infoItems" :key="item.label">
        <div :style="`${item.showSeparator ? '' : 'margin-bottom: 8px'};`" class="info-item">
          <div class="info-item-title-icon">
            <mf-icon :icon="item.icon" color="cinza-d10" size="14" />
            <h2>{{ item.label }}</h2>
          </div>
          <b>{{ item.value }}</b>
        </div>
        <div v-if="item.showSeparator" class="separator" />
      </li>
    </ul>

    <h2 class="presence">Presença nos canais</h2>

    <div class="progress-grid">
      <div v-for="item in progress" :key="item.id" class="progress-item">
        <p>{{ item.label }}</p>
        <progress-bar-chart :bar-color="item.color" :text-color="item.color" :percent="item.value" fill />
      </div>
    </div>
  </div>
</template>

<script>
import { rfvGraphDetails } from '../../../mixins/rfv-graph-details'
import { localeString } from '@/config/helpers.js'
import ProgressBarChart from '@/components/ProgressBarChart.vue'
export default {
  name: 'RfvCardItem',
  components: { ProgressBarChart },
  mixins: [rfvGraphDetails],
  data: () => ({}),
  computed: {
    infoItems() {
      return [
        {
          icon: 'group',
          label: 'Consumidores',
          value: localeString(this.data.clients),
          showSeparator: true,
        },
        {
          icon: 'payments',
          label: 'Faturamento',
          value: 'R$' + localeString(this.data.revenue, 0),
          showSeparator: false,
        },
        {
          icon: 'percent',
          label: 'do fat. geral',
          value: this.data.percentageRevenue + '%',
          showSeparator: true,
        },
        {
          icon: 'event_repeat',
          label: 'Frequência',
          value: localeString(this.data.frequency),
          showSeparator: true,
        },
        {
          icon: 'today',
          label: 'Recência',
          value: localeString(this.data.recency),
          showSeparator: true,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
ul {
  padding: 0;
}

li {
  list-style: none;
}

.rfv-card-item {
  padding: 10px;
  border-radius: 4px;
  border: 2px solid;
}

::v-deep .title-container {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  .emoji-container {
    width: 22px;
    height: 22px;
    font-size: 12px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      margin-bottom: 2px;
    }
  }

  h1 {
    font-size: 16px;
    font-weight: 700;
    color: $cinza-d10;
    line-height: 120%;
    margin-left: 8px;
    margin-bottom: 0;
  }
}
::v-deep .info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  h2 {
    font-size: 12px;
    color: $cinza-d10;
    font-weight: 400;
    margin-left: 4px;
    margin-bottom: 0;
  }

  b {
    font-size: 12px;
    margin-bottom: 0;
    color: $cinza-0;
  }

  .info-item-title-icon {
    display: flex;
    align-items: center;
  }
}

.separator {
  width: 100%;
  height: 1px;
  background-color: $cinza-l70;
  margin: 8px 0;
}

::v-deep .presence {
  color: $cinza-d10;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 8px;
}

::v-deep .progress-grid {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 16px;
  p {
    color: $cinza-0;
    font-size: 10px;
    line-height: 120%;
    margin-bottom: 4px;
  }

  .progress-item {
    flex-basis: calc(50% - 8px);
  }
}
</style>
